import { render, staticRenderFns } from "./SociosEmpresa.vue?vue&type=template&id=3e17de98&"
import script from "./SociosEmpresa.vue?vue&type=script&lang=js&"
export * from "./SociosEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./SociosEmpresa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports